/**
 * Market data the account panels need: outcomeMeta (side names / titles) and mids (mark outcome shares).
 * Mids are the shared hl/mids.ts ones (#2242 rev 3): the same query and the same ref-counted `allMids` stream the rest
 * of the site holds from entry (GlobalStreams, #1809), so a panel on any page adds no request. Each frame carries the
 * whole map, so a reconnect needs no REST read.
 */
import { useOutcomeMeta as useCatalog } from '../catalog/useOutcomeMeta';
import { useAllMids } from '../hl/mids';
import type { AllMidsResponse, OutcomeMetaResponse } from '../hl/types';

export function useOutcomeMeta(enabled = true): OutcomeMetaResponse | undefined {
  return useCatalog(enabled).data;
}

export function useMids(enabled = true): AllMidsResponse | undefined {
  return useAllMids(enabled).mids;
}
